// @ts-nocheck
/* eslint-disable */
import { setItem, getItem } from "~/es6/localstorage";
import { makeEvent } from "~/lib/signals";
import { store } from "~/state/store";
import { watch, watchCurrentUser } from "~/state/util";

class Licence {
	constructor() {
		// dokumenty, ktere je nutne schvalit
		this._needed = [];
		// jiz schvalene dokumenty
		this._approved = this._getLocalApproved();
		// od posledne updatovane
		this._updated = [];
		// jakykoliv dokument, ke kteremu mame nejaka data - cache na dokumenty, abychom se porad nedoptavali zbytecne backendu
		this._documents = [];

		const w = watch(store.getState, "user", watchCurrentUser);
		this._storeUnsubscribe = store.subscribe(w((newUser) => {
			this._checkLicences(newUser.user);
		}));

		const { user } = store.getState().user;

		this._checkLicences(user);
	}

	destroy() {
		this._storeUnsubscribe();
	}

	get needed() {
		return Array.from(this._needed);
	}

	get approved() {
		return Array.from(this._approved);
	}

	get updated() {
		return Array.from(this._updated);
	}

	// vrati info o schvalene verzi daneho dokumentu, nebo null, pokud neni schvaleny
	getApprove(documentType) {
		const documentTypes = Array.isArray(documentType) ? documentType : [documentType];
		const approved = this.approved;
		const types = approved.map(doc => doc.document_type);

		return documentTypes.map(doc => {
			const index = types.indexOf(doc);

			return index !== -1 ? approved[index] : null;
		});
	}

	// nastavi approve u dokumentu a vrati promise
	setApprove(documentType, approve) {
		const documentTypes = Array.isArray(documentType) ? documentType : [documentType];
		const { user } = store.getState().user;
		const logged = user.state === "green";
		const date = parseInt(new Date().getTime() / 1000);

		let approved = this.approved;

		// smazeme tomuhle dokumentu stary zaznam
		approved = approved.filter(doc => documentTypes.indexOf(doc.document_type) === -1);

		return Promise.all(documentTypes.map(docType => this.getDocument(docType))).then(docs => {
			const documents = [];

			docs.forEach(doc => {
				// pokud budeme posilat na server, slozime si pole dokumentu
				if (logged) {
					documents.push({
						document_id: doc.document_id,
						date,
						agree: approve
					});
				}

				// pokud je schvalujeme, tak je pridame zpet s aktualnim datem do approved
				if (approve) {
					approved.push({
						document_type: doc.document_type,
						document_id: doc.document_id,
						date,
						version: doc.version
					});
				}
			});

			// aktualizujeme _approved
			this._approved = approved;

			return logged ? Mapy.ProviderLicence.approve({ documents }) : Promise.resolve(this._setLocalApproved(approved));
		}, () => {});
	}

	// pri prihlaseni uzivatele zkontrolujeme jeho souhlasy
	_checkLicences(user) {
		// je prihlaseny, nacteme souhlasy ze serveru
		if (user.state === "green") {
			Mapy.ProviderLicence.check().promise.then(response => {
				if (!("data" in response)) {
					return;
				}

				// zapamatujeme si, co nas bude casem zajimat
				this._approved = Array.from(response.data.approved);
				this._needed = Array.from(response.data.needed);
				if (this._needed.length) {
					this._documents = this._needed;
				}
				this._updated = Array.from(response.data.update);

				makeEvent("licence-approved", this);

				// pokud je neco treba odsouhlasit, vysleme signal
				if (response.data.needed.length) {
					makeEvent("licence-needed", this);
				}
			}, () => {});
		// neprihlaseny ma svoje souhlasy v localStorage a my si je nacteme
		} else {
			this._approved = this._getLocalApproved();
			makeEvent("licence-approved", this);
		}
	}

	_setLocalApproved(approved) {
		setItem("licencesApproved", JSON.stringify(approved));
	}

	_getLocalApproved() {
		try {
			return JSON.parse(getItem("licencesApproved")) || [];
		} catch (err) {
			return [];
		}
	}

	getDocument(documentType) {
		const newDoc = this._documents.find(doc => doc.document_type === documentType);

		if (newDoc) {
			return Promise.resolve(Object.assign({}, newDoc));
		} else {
			return Mapy.ProviderLicence.documents({
				types: documentType
			}).promise.then(response => {
				this._documents.push(response.data.documents[0]);

				return response.data.documents[0];
			}, () => {});
		}
	}
}

Mapy.Licence = Licence;
